/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Blog_Reading_MinutesInputs */

const en_blog_reading_minutes = /** @type {(inputs: Blog_Reading_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min read`)
};

const pl_blog_reading_minutes = /** @type {(inputs: Blog_Reading_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min czytania`)
};

/**
* | output |
* | --- |
* | "{minutes} min read" |
*
* @param {Blog_Reading_MinutesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_reading_minutes = /** @type {((inputs: Blog_Reading_MinutesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Reading_MinutesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_reading_minutes(inputs)
	return en_blog_reading_minutes(inputs)
});